import { KBarAnimator, KBarPortal, KBarPositioner, KBarResults, useKBar, useMatches } from 'kbar'
import { IS_MAC } from '../common/const'
import { renderKey } from './keyIcons'
import style from './kbar.module.scss'
import { useEffect } from 'react'

type Props = {
  className?: string
}

export function KBarModalUI() {
  const { query } = useKBar()

  return (
    <KBarPortal data-kbar-portal>
      <KBarPositioner className={style.kbarProvider} data-kbar-positioner>
        <KBarAnimator className={style.kbarAnimator} data-kbar-animator>
          <div className={`${style.kbarHeader} ${style.kbarLine}`} data-kbar-container-header>
            <div className={style.container} data-kbar-container-header-title>
              <span>
                <i className="icon-aytmfd-keyboard-shortcuts" />
              </span>
              <span>Keyboard Shortcuts</span>
              <span className={style.letter} data-kbar-container-shortcut>
                {IS_MAC ? 'Cmd + K' : 'Ctrl + K'}
              </span>
            </div>
            <div>
              <button
                className={style.kbarCloseButton}
                data-kbar-close-button
                aria-label="Close KBar"
                onClick={() => query.toggle()}
              >
                <i className="icon-aytmfd-close-v2" />
              </button>
            </div>
          </div>

          <MyKBarSearch data-kbar-search className={style.kbarInput} />
          <RenderResults />
          <div className={style.kbarFooter} data-kbar-container-footer>
            <div className={style.header}>
              <i className="icon-aytmfd-lighthouse"></i>
            </div>
            <div data-kbar-container-footer-text>
              Check out{' '}
              <a href="https://academy.aytm.com/" className={style.link} data-kbar-container-footer-link>
                Lighthouse Academy
              </a>{' '}
              for training and certifications.
              <p> In‑platform help is coming soon! </p>
            </div>
          </div>
        </KBarAnimator>
      </KBarPositioner>
    </KBarPortal>
  )
}
function RenderResults() {
  const { results } = useMatches()
  return (
    <KBarResults
      items={results}
      onRender={({ item, active }) =>
        typeof item === 'string' ? (
          <div className={style.kbarTitle} data-kbar-title={item} />
        ) : (
          <div
            className={style.groupText}
            onClick={event => {
              if (!item.perform) {
                event.preventDefault()
                event.stopPropagation()
              }
            }}
            data-kbar-title-item={item.id}
          >
            <div
              className={`${
                item.section === 'Editor Page Shortcuts informational'
                  ? `${style.kbarInformLine} ${active ? style.activeInform : ''}`
                  : `${style.kbarLine} ${active ? style.active : ''}`
              }`}
              data-kbar-line
            >
              <div className={`${style.groupText} ${style.title}`} data-kbar-title-item-name={item.id}>
                {item.name}
              </div>
              <div className={style.kbarLineLetters} data-kbar-shortcut-keys={item.id}>
                {item.shortcut
                  ? item.shortcut.map((key, index) => (
                      <div
                        key={`shortcut-key-${key + '-' + index}`}
                        className={style.kbarLineLetterWrapper}
                        data-kbar-shortcut-key-container
                      >
                        <div
                          key={index}
                          className={`  ${active ? style.active : ''} ${
                            item.subtitle && item.id === 'clone-field' && index > 2
                              ? `${style.groupTextClone}`
                              : `${style.groupText} ${style.letter}`
                          }`}
                          data-kbar-shortcut-key
                        >
                          {renderKey(key)}
                        </div>

                        {index === 1 && item.subtitle && item.id === 'clone-field' ? (
                          <div className={`${style.groupText} ${style.subtitle}`} data-kbar-subtitle={item.id}>
                            {item.subtitle}
                          </div>
                        ) : null}
                      </div>
                    ))
                  : null}
              </div>
              {item.subtitle && item.id !== 'clone-field' ? (
                <div className={`${style.groupText} ${style.subtitle}`} data-kbar-subtitle={item.id}>
                  {item.subtitle}
                </div>
              ) : null}
            </div>
          </div>
        )
      }
    />
  )
}

export function MyKBarSearch({ className }: Props) {
  const { query, search } = useKBar(state => {
    return {
      search: state.searchQuery
    }
  })
  useEffect(() => {
    query.setSearch('')
  }, [query])

  return (
    <input
      data-kbar-search-input
      className={className}
      ref={query.inputRefSetter}
      value={search}
      onChange={event => query.setSearch(event.currentTarget.value)}
      placeholder="Search for available shortcuts..."
      autoFocus
    />
  )
}
